const moreBtnStore = {
  state: {
    moreBtnPlayListType: null,
    moreBtnCustomerPlaylistProductId: null,
    moreBtnItemIndex: null,
    moreBtnOtherTuneModal: false,
    moreBtnIsumTuneModal: false
  },
  mutations: {
    updateMoreBtnPlayListType (state, playListType) {
      state.moreBtnPlayListType = playListType
    },
    updateMoreBtnCustomerPlaylistProductId (state, customerPlaylistProductId) {
      state.moreBtnCustomerPlaylistProductId = customerPlaylistProductId
    },
    updateMoreBtnItemIndex (state, itemIndex) {
      state.moreBtnItemIndex = itemIndex
    },
    updateMoreBtnOtherTuneModalFlag (state, flag) {
      state.moreBtnOtherTuneModal = flag
    },
    updateMoreBtnIsumTuneModalFlag (state, flag) {
      state.moreBtnIsumTuneModal = flag
    }
  },
  actions: {
    switchMoreBtnOtherTuneModalFlag (context, flag) {
      this.commit('updateMoreBtnOtherTuneModalFlag', flag)
    },
    switchMoreBtnIsumTuneModalFlag (context, flag) {
      this.commit('updateMoreBtnIsumTuneModalFlag', flag)
    },
    setMoreBtnModalParam (context, [playListType, customerPlaylistProductId, itemIndex]) {
      this.commit('updateMoreBtnPlayListType', playListType)
      this.commit('updateMoreBtnCustomerPlaylistProductId', customerPlaylistProductId)
      this.commit('updateMoreBtnItemIndex', itemIndex)
    }
  },
  getters: {
    getMoreBtnModalParam (state) {
      return {
        moreBtnPlayListType: state.moreBtnPlayListType,
        moreBtnCustomerPlaylistProductId: state.moreBtnCustomerPlaylistProductId,
        moreBtnItemIndex: state.moreBtnItemIndex,
        moreBtnOtherTuneModal: state.moreBtnOtherTuneModal
      }
    }
  }
}
export default moreBtnStore



// WEBPACK FOOTER //
// ./src/store/MoreBtnStore.js